import React from 'react';
import type { GroupBase, SingleValueProps } from 'react-select';
import { components } from 'react-select';
import classNames from 'classnames';

/**
 * This CustomValue class adds two custom classes which aren't used, yet. But we can extend them to add custom styling
 * if we'd like!
 *
 * This is a useful "base component" to build off of for any custom value components.
 */
const CustomValue = <Option, IsMulti extends boolean>(
    props: SingleValueProps<Option, IsMulti, GroupBase<Option>>,
) => {
    const { className, isDisabled, children } = props;
    const newClassName = classNames(
        {
            'single-value': true,
            'single-value--is-disabled': isDisabled,
        },
        className,
    );
    return (
        <components.SingleValue className={newClassName} {...props}>
            {children}
        </components.SingleValue>
    );
};

export default CustomValue;
